

































































































import { Component, Vue, Mixins, Prop,Watch } from "vue-property-decorator";
import Loading from "@/mixins/loading";
import TablePagination from "@/mixins/tablePagination";
// api
import {
  memberList,
  memberRebateList,
  updateRebateStatus,
  updateDescription,
} from "@/api/vip";
import {
  MemberInfo,
  MemberRebateList,
  MemberRebateListParams,
  UpdateDescription,
} from "@/types/api/vip";
import debounce from "@/utils/debounce";


// 初始化表单
const initForm: UpdateDescription = {
  id: 0,
  description: "",
};

@Component
export default class Table extends Mixins(Loading, TablePagination) {
  @Prop() status!: number;
  @Prop() phone!: string;
  @Prop() shopName!: string;
  @Prop() userName!: string;

  private tableData: Array<MemberRebateList> = [];
  imgUrl: string = "";
  dialogTitle: string = "";
  dialogVisibleImg: boolean = false;
  form: UpdateDescription = initForm;
  dialogVisibleRemark: boolean = false;
  tableChange:boolean = true;

  mounted() {
    this.getData();
  }


  /**
   * 监听
   */
  @Watch("status")
  searchValue() {
      this.tableChange = false;
      this.$nextTick(()=>{
        this.tableChange = true;
      });
  }
  /**
   * methods
   */
  getData(): void {
    this.showLoading();
    memberRebateList({
      pageNum: this.currentPage,
      pageSize: this.pageSize,
      phone: this.phone,
      shopName: this.shopName,
      status: this.status,
      userName: this.userName,
    }).then((res: any) => {
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.hideLoading();
    });
  }
  // 预览图片
  previewPic(url: string, title: string) {
    alert(1);
    this.dialogTitle = title;
    this.imgUrl = url;
    this.dialogVisibleImg = true;
  }
  // 修改审核状态
  handleState(row: MemberRebateList, type: number) {
    let title: string = "";
    let desc: string = "";
    let status = row.status;
    if (type == 1) {
      title = `审核`;
      desc = `是否审核通过 ”${row.shopName}“ 提现操作申请 ?`;
    } else {
      title = "拒绝申请";
      desc = `是否拒绝 ”${row.shopName}“ 提现操作`;
    }
    this.$confirm(desc, title, {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: type == 1 ? "warning" : "error",
    }).then(() => {
      updateRebateStatus({ id: row.id, status: type == 1 ? 3 : 2 }).then(
        (res: any) => {
          this.$message.success("修改成功");
          this.getData();
        }
      );
    });
  }
  // 修改备注
  updateRemark(row: MemberRebateList) {
    this.form.id = row.id;
    this.form.description = row.note;
    this.dialogVisibleRemark = true;
  }
  // 取消
  cancelUpdateRemark() {
    this.dialogVisibleRemark = false;
    this.form = initForm;
  }
  // 确认修改备注
  confirmUpdateRemark(row: MemberRebateList) {
    updateDescription(this.form).then((res) => {
      this.dialogVisibleRemark = false;
      this.$message.success("修改成功");
      this.getData();
      this.form = initForm;
    });
  }
}
